import {createSlice, PayloadAction} from '@reduxjs/toolkit'; 

type InitialState ={
    value:CategoryState;
}

type CategoryState = {
    category:string
}


const initialState = {
    value:{
        category:''
    } as CategoryState, 
     
} as InitialState

export const category = createSlice({
    name:'category',
    initialState,
    reducers:{
        defaultCategory:()=>{
            return initialState
        },
        setCategory:(state,action:PayloadAction<string> )=>{
            return {
                value:{
                    category:action.payload 
                }
            }
        }
    } 
});

export const {defaultCategory, setCategory} = category.actions
export default category.reducer